import { useApi, SKY_API_ENDPOINT } from '@/api';
import { Flex, Box, Heading, KpiSkeleton } from '@blockanalitica/ui';
import { KpiCard } from '@/components';
import { InfoTooltip } from '@/components';
import StarsRequiredRiskCapitalTable from './StarsRequiredRiskCapitalTable';
import { LinkBanner, Page } from '@/components';
export default function RequiredRiskCapitalPage() {
  const [data, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: `/rrc/aggregates/`
  });

  if (error) {
    throw error;
  }

  return (
    <Page title="Star Agents Risk Capital & Requirements Monitor">
      <LinkBanner
        text="More about the Sky Protocol Star Risk"
        linkTo="https://sky-atlas.io/#A.3.2.1.1">
        <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
          <Heading size="2">About the Sky Protocol Star Risk</Heading>
          <br />
          Sky&apos;s risk framework is based on Basel III and leverages the
          concepts of Actively Stabilizing Collateral for USDS peg stability and
          Required Risk Capital for sustainable capital allocation. This page
          offers a realtime view into the Star Agent risk capital requirements
          and their current state of risk capital including a full ecosystem
          overview.
        </Box>
      </LinkBanner>
      {!data?.data ? (
        <>
          <Flex gap="xs">
            <KpiSkeleton />
            <KpiSkeleton />
          </Flex>
          <Flex gap="xs">
            <KpiSkeleton />
            <KpiSkeleton />
            <KpiSkeleton />
          </Flex>
        </>
      ) : (
        <>
          <Flex gap="xs">
            <KpiCard
              title={
                <Flex gap="3xs">
                  Total Exposure
                  <InfoTooltip text="The Sky Ecosystem's aggregate allocations to Star Agents." />
                </Flex>
              }
              data={data.data}
              field="total_exposure"
              options={{ currency: 'USD' }}
            />
            <KpiCard
              title={
                <Flex gap="3xs">
                  % of Exposure
                  <InfoTooltip text="Total Required Risk Capital divided by Total Exposure." />
                </Flex>
              }
              data={data.data}
              field="total_exposure_share"
              options={{
                percentage: true,
                variants: {
                  valuePercentageValue: 'dynamic'
                }
              }}
            />
          </Flex>
          <Flex gap="xs">
            <KpiCard
              title={
                <Flex gap="3xs">
                  Total RC
                  <InfoTooltip text="Aggregate Star Agents Risk Capital (treasury assets held in their SubProxies)." />
                </Flex>
              }
              data={data.data}
              field="total_rc"
              options={{ currency: 'USD', notation: 'compact' }}
            />
            <KpiCard
              title={
                <Flex gap="3xs">
                  Total RRC
                  <InfoTooltip text="Total Required Risk Capital is the sum of all risk related capital requirements across Star Agents." />
                </Flex>
              }
              data={data.data}
              field="total_rrc"
              options={{ currency: 'USD', notation: 'compact' }}
            />
            <KpiCard
              title={
                <Flex gap="3xs">
                  Total Encumbrance Ratio
                  <InfoTooltip text="Aggregate Star Agents Encumbrance Ratio. Encumbrance Ratio is the total Required Risk Capital divided by total Risk Capital." />
                </Flex>
              }
              data={data.data}
              field="encumbrance_ratio"
              options={{
                percentage: true,
                variants: {
                  valuePercentageValue: 'dynamic'
                }
              }}
            />
          </Flex>
        </>
      )}
      <StarsRequiredRiskCapitalTable />
    </Page>
  );
}
